import {Directive} from '@angular/core';

@Directive({
  selector: '[icon]',
  standalone: true
})
export class IconDirective {

  constructor() {
  }

}
